
import ProductLayout from "layouts/ProductLayout";
import ManageBank from "components/ManageBank";
import FooterBank from "components/ManageBank/FooterBank";


function ManageBankPage() {

  return (
    <ProductLayout namePage="จัดการบัญชีธนาคาร" footerComponent={<FooterBank />}  >
      <div className="layout-content">
        <ManageBank />
      </div>
    </ProductLayout>
  );
}

export default ManageBankPage;